import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/delay';
import { FetchdataServiceService } from './fetchdata-service.service';
import { DataserviceComponent } from './shared/dataservice/dataservice.component'
@Injectable()
export class VINServiceService {
  constructor(private srv: FetchdataServiceService, public dataservice: DataserviceComponent) {
 
}


  //Url = "https://localhost:44354/api/Contactus";
  Url = "https://contactusapi.kia.ca/api/Contactus"
  validateVIN(vin: string) {
    //return this.http
    //  .get('assets/users.json')
    //  .delay(1000)
    //  .map(res => res.json())
    //  .map(users => users.filter(user => user.email === email))
    //  .map(users => !users.length);

    return this.srv.validatevin(this.Url + '/validatevin', vin)
    .delay(1000);
//.subscribe((res) => {
         // },error => { success = "false" });

  }
}
